export default __webpack_public_path__ + "static/media/TTIS_logo.77ddcfc2.jpg";